
export const servicesData = {
    desentupimentos: {
        id: 'desentupimentos',
        title: 'Desentupimentos Urgentes',
        subtitle: 'Serviço Emergencial 24h em Lisboa - Resposta rápida',
        description: 'Somos especialistas em desentupimentos urgentes e emergenciais em Lisboa. Resolvemos todos os tipos de entupimentos em residências e estabelecimentos comerciais com equipamento profissional de última geração. Atendimento 24h, serviço emergencial, técnicos locais em Lisboa e Margem Sul, diagnóstico no local, equipamento de alta pressão, inspeção por câmera, garantia no serviço e preço transparente.',
        shortDescription: 'Somos especialistas em desentupimentos urgentes e emergenciais em Lisboa. Resolvemos todos os tipos de entupimentos em residências e estabelecimentos comerciais com equipamento profissional de última geração.',
        image: '/images/services/desentupimento_profissional.webp',
        heroImage: '/images/services/desentupimento_profissional.webp',
        imagePosition: 'center bottom',
        problems: [
            'Sanita entupida',
            'Pia entupida',
            'Ralo entupido',
            'Esgoto entupido',
            'Sifão entupido',
            'Coluna de prédio entupida',
            'Fossa séptica entupida',
            'Canos externos entupidos',
            'Caixa de gordura entupida',
            'desentupimento urgente',
            'canalização entupida',
            'canalizador 24h',
            'desentupimento Lisboa'
        ],
        features: [
            'Atendimento 24h urgente',
            'Equipamento de alta pressão',
            'Inspeção por câmera',
            'Diagnóstico no local',
            'Técnicos especializados',
            'Garantia no serviço',
            'Preço transparente',
            'Resposta rápida'
        ]
    },
    fugas: {
        id: 'fugas',
        title: 'Detecção de Fugas de Água',
        subtitle: 'Tecnologia avançada para localizar fugas sem quebrar nada - Diagnóstico preciso',
        description: 'Detetamos e reparamos fugas de água com equipamento profissional de última geração. Utilizamos tecnologia avançada para localizar fugas ocultas em paredes, pavimentos e canos sem necessidade de quebrar tudo. Serviço de detecção não invasiva, reparação rápida e eficiente, técnicos especializados em Lisboa, diagnóstico preciso, garantia no serviço e preço transparente.',
        shortDescription: 'Detetamos e reparamos fugas de água com equipamento profissional de última geração. Utilizamos tecnologia avançada para localizar fugas ocultas em paredes, pavimentos e canos sem necessidade de quebrar tudo.',
        image: '/images/services/deteccao_fugas_agua_horizontal.webp',
        heroImage: '/images/services/deteccao_fugas_agua_horizontal.webp',
        problems: [
            'Fuga oculta em parede',
            'Fuga em cano',
            'Fuga em pavimento',
            'Fuga em torneira',
            'Fuga em autoclismo',
            'Fuga em máquina de lavar',
            'Fuga em esquentador',
            'Fuga em coluna',
            'Fuga em caixa de água',
            'fuga de água',
            'detecção de fugas',
            'reparar fugas de água',
            'água a escorrer',
            'parede húmida',
            'conta de água alta',
            'detecção fugas Lisboa'
        ],
        features: [
            'Detecção não invasiva',
            'Tecnologia avançada',
            'Localização precisa',
            'Sem necessidade de quebrar',
            'Diagnóstico rápido',
            'Reparação eficiente',
            'Garantia no serviço',
            'Técnicos especializados'
        ]
    },
    reparacao: {
        id: 'reparacao',
        title: 'Reparação de Canalização',
        subtitle: 'Solução rápida para canos partidos e torneiras avariadas - Atendimento 24h',
        description: 'Reparamos canos partidos, torneiras avariadas, autoclismos com problemas e toda a canalização doméstica e comercial. Atendimento rápido com técnicos locais em Lisboa, diagnóstico no local, peças compatíveis de alta qualidade, garantia em serviço e preço transparente.',
        shortDescription: 'Reparamos canos partidos, torneiras avariadas, autoclismos com problemas e toda a canalização doméstica e comercial. Atendimento rápido com técnicos locais em Lisboa.',
        image: '/images/services/reparacao_canalizacao_profissional.webp',
        heroImage: '/images/services/reparacao_canalizacao_profissional.webp',
        problems: [
            'Cano partido',
            'Torneira avariada',
            'Autoclismo com problemas',
            'Válvula com defeito',
            'Sifão com fuga',
            'Junta com problemas',
            'Conexão com fuga',
            'Registo com problemas',
            'Canalização antiga',
            'reparação canalização',
            'canalizador urgente',
            'reparar torneira',
            'reparar cano',
            'reparação Lisboa'
        ],
        features: [
            'Reparação urgente 24h',
            'Peças de alta qualidade',
            'Diagnóstico no local',
            'Técnicos experientes',
            'Garantia em serviço',
            'Preço transparente',
            'Resposta rápida',
            'Atendimento local'
        ]
    },
    instalacao: {
        id: 'instalacao',
        title: 'Instalação de Canalização',
        subtitle: 'Instalação nova com garantia e acabamento profissional',
        description: 'Instalamos canalização nova para casas, apartamentos e estabelecimentos comerciais. Fazemos instalação de canos, torneiras, autoclismos, máquinas de lavar, esquentadores e toda a infraestrutura hidráulica. Equipa própria, materiais de qualidade, acabamento profissional, garantia em todos os serviços e preço claro.',
        shortDescription: 'Instalamos canalização nova para casas, apartamentos e estabelecimentos comerciais. Fazemos instalação de canos, torneiras, autoclismos, máquinas de lavar, esquentadores e toda a infraestrutura hidráulica.',
        image: '/images/services/instalacao_canalizacao_profissional.webp',
        heroImage: '/images/services/instalacao_canalizacao_profissional.webp',
        problems: [
            'Canalização nova',
            'Obra nova',
            'Remodelação',
            'Substituição de canos',
            'Instalação de torneiras',
            'Instalação de autoclismos',
            'Instalação de máquinas',
            'Instalação de esquentadores',
            'Infraestrutura hidráulica',
            'instalação canalização',
            'canalizador obra nova',
            'instalar torneiras',
            'instalar canos',
            'instalação hidráulica',
            'instalação Lisboa',
            'canalizador instalação'
        ],
        features: [
            'Instalação profissional',
            'Materiais de qualidade',
            'Acabamento perfeito',
            'Garantia em todos os serviços',
            'Equipa própria',
            'Preço transparente',
            'Planeamento personalizado',
            'Cumprimento de prazos'
        ]
    },
    manutencao: {
        id: 'manutencao',
        title: 'Manutenção Preventiva',
        subtitle: 'Evite problemas com manutenção programada',
        description: 'Prolongue a vida útil da sua canalização com um plano de manutenção preventiva: inspeção de canos, verificação de pressão, limpeza de sifões, verificação de fugas e teste de equipamentos. Reduz avarias inesperadas, evita custos elevados e melhora o desempenho.',
        shortDescription: 'Prolongue a vida útil da sua canalização com um plano de manutenção preventiva: inspeção de canos, verificação de pressão, limpeza de sifões, verificação de fugas e teste de equipamentos.',
        image: '/images/services/manutencao_preventiva_canalizacao.webp',
        heroImage: '/images/services/manutencao_preventiva_canalizacao.webp',
        problems: [
            'Prevenção de avarias',
            'Inspeção de canos',
            'Verificação de pressão',
            'Limpeza de sifões',
            'Verificação de fugas',
            'Teste de equipamentos',
            'Manutenção programada',
            'Relatório do estado',
            'Economia a longo prazo',
            'manutenção canalização',
            'manutenção preventiva',
            'limpeza canalização',
            'manutenção Lisboa',
            'inspeção técnica'
        ],
        features: [
            'Plano personalizado',
            'Inspeção regular',
            'Relatório detalhado',
            'Prevenção de custos',
            'Técnicos especializados',
            'Equipamento profissional',
            'Garantia de qualidade',
            'Economia a longo prazo'
        ]
    },
    pinturas: {
        id: 'pinturas',
        title: 'Pinturas em Geral',
        subtitle: 'Pintura interior, exterior e em altura com acabamento profissional',
        description: 'Serviços completos de pintura: interiores, exteriores e trabalhos em altura com técnica de rapel. Utilizamos tintas premium e processos profissionais para garantir acabamento duradouro em residências e edifícios comerciais em Lisboa.',
        shortDescription: 'Serviços completos de pintura: interiores, exteriores e trabalhos em altura com técnica de rapel. Utilizamos tintas premium e processos profissionais para garantir acabamento duradouro.',
        image: '/images/services/pinturas_em_geral_profissional.webp',
        heroImage: '/images/services/pinturas_em_geral_profissional.webp',
        problems: [
            'Pintura interior',
            'Pintura exterior',
            'Pintura em altura (rapel)',
            'Preparação de superfícies',
            'Reparação de fissuras',
            'Proteção contra intempéries',
            'Pintura decorativa',
            'Acabamento profissional',
            'Renovação de fachadas',
            'pintura Lisboa',
            'pintor profissional',
            'renovação pintura'
        ],
        features: [
            'Equipa especializada em rapel',
            'Tintas de alta qualidade',
            'Preparação adequada das superfícies',
            'Acabamento duradouro',
            'Equipamentos de segurança certificados',
            'Garantia total no serviço',
            'Planeamento personalizado',
            'Relatórios de acompanhamento'
        ]
    },
    'limpeza-vidros': {
        id: 'limpeza-vidros',
        title: 'Limpeza de Vidros de Fachada (Rapel)',
        subtitle: 'Limpeza profissional em altura com técnica de rapel',
        description: 'Serviço especializado de limpeza de vidros de fachada em altura utilizando técnica de rapel. Trabalhamos em edifícios comerciais e residenciais, garantindo segurança e qualidade no serviço.',
        shortDescription: 'Serviço especializado de limpeza de vidros de fachada em altura utilizando técnica de rapel. Trabalhamos em edifícios comerciais e residenciais, garantindo segurança e qualidade no serviço.',
        image: '/images/services/limpeza_vidros_fachada_rapel.webp',
        heroImage: '/images/services/limpeza_vidros_fachada_rapel.webp',
        problems: [
            'Limpeza em altura',
            'Fachadas sujas',
            'Vidros opacos',
            'Edifícios comerciais',
            'Edifícios residenciais',
            'Janelas altas',
            'Vidros difíceis de alcançar',
            'Limpeza profissional',
            'Segurança garantida',
            'limpeza vidros fachada',
            'limpeza rapel',
            'limpeza Lisboa'
        ],
        features: [
            'Técnica de rapel',
            'Segurança total',
            'Equipamento certificado',
            'Técnicos especializados',
            'Limpeza profunda',
            'Qualidade garantida',
            'Seguro e responsável',
            'Preço transparente'
        ]
    }
};

export const generalAssets = {
    aboutUs: '/images/services/plumbers_now_cropped.webp'
};
